module.exports = __webpack_public_path__ + "static/GraduatingStudents-8ac031052883287ff2dc107df0562b24.webp";